export default __webpack_public_path__ + "static/media/database.32673275.png";